import '@rainbow-me/rainbowkit/styles.css';
import { 
  getDefaultConfig, 
  RainbowKitProvider, 
  darkTheme,
  connectorsForWallets 
} from '@rainbow-me/rainbowkit';
import {
  rainbowWallet,
  metaMaskWallet,
  coinbaseWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { base, arbitrum, polygon } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'demo-project-id';

// Configure only the wallets we want
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Popular',
      wallets: [
        metaMaskWallet,
        rainbowWallet,
        coinbaseWallet,
        walletConnectWallet,
      ],
    },
  ],
  {
    appName: 'Bet4Peer',
    projectId,
  }
);

// RainbowKit config with MAINNET chains
export const config = createConfig({
  connectors,
  chains: [base, arbitrum, polygon],
  transports: {
    [base.id]: http('https://mainnet.base.org'),
    [arbitrum.id]: http('https://arb1.arbitrum.io/rpc'),
    [polygon.id]: http('https://polygon-rpc.com'),
  },
});

// Query client
export const queryClient = new QueryClient();

// Custom theme matching Bet4Peer colors
export const bet4peerTheme = darkTheme({
  accentColor: '#00FF66',
  accentColorForeground: '#0A0A0C',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
});

// Merge with custom colors
bet4peerTheme.colors = {
  ...bet4peerTheme.colors,
  connectButtonBackground: '#00FF66',
  connectButtonBackgroundError: '#FF6B6B',
  connectButtonInnerBackground: 'linear-gradient(135deg, #6F3FCA 0%, #00FF66 100%)',
  connectButtonText: '#0A0A0C',
  connectButtonTextError: '#FFF',
  modalBackground: '#0A0A0C',
  modalBorder: 'rgba(255, 255, 255, 0.1)',
  modalText: '#FFF',
  modalTextSecondary: 'rgba(255, 255, 255, 0.5)',
  profileAction: '#1a0a30',
  profileActionHover: '#2a1a40',
  profileForeground: '#1a0a30',
  selectedOptionBorder: '#00FF66',
  standby: '#FFD700',
};

export { RainbowKitProvider, WagmiProvider, QueryClientProvider };
